import { EventName, LogChannelMessageMappings } from './constants/messages';
import { Injectable, inject } from '@angular/core';
import { ClientsiteSharedLoggingService, LoggingPropertyConfiguration } from '@rx-applications/clientsite/core/logging';
import { BaseConfig, EnvironmentTracking } from '@rx-applications/clientsite/shared/config/utils';

@Injectable({
  providedIn: 'root',
})
export class ConfigLoggerService {
  #clientsiteSharedLoggingService: ClientsiteSharedLoggingService = inject(ClientsiteSharedLoggingService);

  public UserTokenNotValidForThisPortal() {
    const messageAndChannelMapping = LogChannelMessageMappings[EventName.UserTokenNotValidForThisPortal];
    this.#clientsiteSharedLoggingService.sendToPubSub(messageAndChannelMapping.channels, messageAndChannelMapping.message);
  }

  public init(environmentTracking: EnvironmentTracking, baseConfig?: BaseConfig) {
    this.#clientsiteSharedLoggingService.init({ environmentTracking, baseConfig });
  }

  public setProperties(loggingPropertyConfiguration: LoggingPropertyConfiguration) {
    this.#clientsiteSharedLoggingService.createSetup(loggingPropertyConfiguration);
  }
}
